import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import { ITerritoryConfiguration } from '../../common/types/apiSchema';

export {
  GET_FAVORITES,
  GET_TERRITORY_CONFIGURATION,
  IFavoritesQueryVariables,
  ITerritoryConfigurationData,
  ITerritoryConfigurationQueryVariables,
};

const GET_FAVORITES: DocumentNode = gql`
  query Favorites($userId: String!) {
    favorites(userId: $userId)
  }
`;

const GET_TERRITORY_CONFIGURATION: DocumentNode = gql`
  query TerritoryConfiguration($territory: String, $userTerritory: String) {
    territoryConfiguration(territory: $territory, userTerritory: $userTerritory) {
      isFlightFunctionalityEnabled
      flightsAvailableAtCSPage
      depositAvailableAtCSPage
      isZeroDepositDisplayable
      posLocale
      userLocale
    }
  }
`;

interface IFavoritesQueryVariables {
  userId: string;
}

interface ITerritoryConfigurationQueryVariables {
  territory: string;
  userTerritory: string;
}

interface ITerritoryConfigurationData {
  territoryConfiguration: ITerritoryConfiguration;
}
